import * as React from 'react';

export const ExpandedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Trailing">
      <path
        id="Vector"
        d="M13.3332 12.5012C13.1199 12.5012 12.9065 12.4196 12.744 12.2571L9.99991 9.51293L7.25577 12.2571C6.92993 12.5829 6.40322 12.5829 6.07738 12.2571C5.75155 11.9312 5.75155 11.4045 6.07738 11.0787L9.41072 7.74535C9.73655 7.41952 10.2633 7.41952 10.5891 7.74535L13.9224 11.0787C14.2483 11.4045 14.2483 11.9312 13.9224 12.2571C13.7599 12.4196 13.5466 12.5012 13.3332 12.5012Z"
        fill="#1D6EAA"
      />
    </g>
  </svg>
);
